import { Cached } from "@coris-ts/helpers/utilities"
import { type ApiRequestService } from "@coris-ts/repository/data-source/api-request.service"
import axios from "./http/axios.interceptor"
import { AxiosApiRequestService } from "./http/api-request.service"
import { type PaymentComponent, PaymentDefaultModule } from "./payment/payment.component"
import { ApiBaseUrl } from "../config"

export interface MainComponent {
  getPaymentComponent: () => PaymentComponent
}

class MainDefaultModule implements MainComponent {
  private readonly apiRequestService: ApiRequestService

  constructor() {
    this.apiRequestService = new AxiosApiRequestService(ApiBaseUrl, axios)
  }

  @Cached()
  public getPaymentComponent(): PaymentComponent {
    return new PaymentDefaultModule(this.apiRequestService)
  }
}

export const MainModule = new MainDefaultModule()
